module.exports = "/assets/landing-rwx/instagram/insta-feed-6.jpg?oAe8U4G";